/**
 * Directive: plus
 */
angular.module('acme.common.directive.plus', [])
.directive('plus', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/plus/plus.tpl.html',
      scope: {
        action: '&'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.plus = {

          model: "+",

          action: function() {
            if (typeof($scope.action) === 'function') {
              $scope.action();
            }
          }

        };

      }]

    };

}]);